const Themes = {
	Light: 'light',
	Dark: 'dark',
}

export default Themes
